export default {
  path: '/dataException',
  name: 'DataException',
  meta: {
    auth: false,
    title: '暂无权限',
  },
  component: () => import('_views/DataException.vue'),
}
